
import React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
}));

const GALLERY = 'GALLERY';
const DOWNLOAD = 'DOWNLOAD';
const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
};

const cards = [
  {
    key: 1,
    thumbprint: '/images/IMG_2028hj800.jpg',
    heading: '영도',
    text: 'Photos from 2002 & 2006 Korea trip and more.',
    link: '/galleryOne',
    type: GALLERY
  },
  {
    key: 2,
    thumbprint: '/julia/lotus934640.jpg',
    heading: 'Julia',
    text: "Photos from 2004 Odilia's visit.",
    link: '/galleryTwo',
    type: GALLERY
  },
  {
    key: 3,
    thumbprint: '/images/FlyWithMe.jpg',
    heading: 'FLY with ME',
    text: "AMERICAN EXPERIENCE FILMS   (Season36 Ep2) of PBS",
    link: 'https://drive.google.com/file/d/1yHevZrrivABMRQ_IybXRsUczrbOWErbU/view?usp=drive_link',
    type: DOWNLOAD
  }
];

const Main = () => {
  const classes = useStyles();
  const history = useHistory();
  const openLink = (link) => {
    history.push(link);
  }

  return (
    <React.Fragment>
      <main>
      {/* Hero unit */}
      <div className={classes.heroContent}>
        <Container maxWidth="sm">
          <Typography component="h1" variant="h2" align="center" color="textPrimary" gutterBottom>
            Youn's Album
          </Typography>
          <Typography variant="h5" align="center" color="textSecondary" paragraph>
                
                                    
                                                
          </Typography>
          <div className={classes.heroButtons}>
            <Grid container spacing={2} justify="center">
              <Grid item>
                <Button href="/korea/album/index.html" target="_blank" variant="contained" color="primary">
                  Korea Gallery
                </Button>
              </Grid>
              <Grid item>
                <Button href="/beijing/src/index.html" target="_blank" variant="outlined" color="primary">
                  Beijing Gallery
                </Button>
              </Grid>
              <Grid item>
                <Button href="/yellowstone2005/index.htm" target="_blank" variant="outlined" color="primary">
                  Yellowstone Gallery
                </Button>
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
      <Container className={classes.cardGrid} maxWidth="md">
        {/* End hero unit */}
        <Grid container spacing={4}>
          {cards.map((card) => (
            <Grid item key={card.key} xs={12} sm={6} md={4}>
              <Card className={classes.card}>
	        {(card.type === GALLERY)
			? 
			<> 
			<CardActionArea onClick={() => openLink(card.link)}>
				<CardMedia
                    			className={classes.cardMedia}
                    			image={card.thumbprint}
                    			title="Image title"
                  		/>
                  		<CardContent className={classes.cardContent}>
                    			<Typography gutterBottom variant="h5" component="h2">
                      				{card.heading}
                    			</Typography>
                    			<Typography>
                      				{card.text}
                    			</Typography>
                  		</CardContent>
                	</CardActionArea>
			<CardActions>
                  		<Button onClick={() => openLink(card.link)} size="small" color="primary">
                    			View
                  		</Button>

                	</CardActions>
			</>
			: 
			<>
			<CardActionArea onClick={() => openInNewTab(card.link)}>
                                <CardMedia
                                        className={classes.cardMedia}
                                        image={card.thumbprint}
                                        title="Image title"
                                />
                                <CardContent className={classes.cardContent}>
                                        <Typography gutterBottom variant="h5" component="h2">
                                                {card.heading}
                                        </Typography>
                                        <Typography>
                                                {card.text}
                                        </Typography>
                                </CardContent>
                        </CardActionArea>
                        <CardActions>
                                <Button onClick={() => openInNewTab(card.link)} size="small" color="primary">
                                        Download
                                </Button>

                        </CardActions>
                        </>
		
		}
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
      </main>
  </React.Fragment>
  );
}

export default Main
